export default __webpack_public_path__ + "static/media/Project_Website.9d9b0c6a.png";